var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-alert',{staticClass:"mt-6 mx-auto d-flex",staticStyle:{"text-align":"center"},attrs:{"max-width":"800","type":"error","text":""}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }